var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverspeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.048,
    height: 25.704,
    viewBox: "0 0 33.048 25.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overspeed",
    transform: "translate(-155 -210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M155.918,470.72h6.12a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-6.12a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,470.72Z",
    transform: "translate(0 -240.273)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M155.918,423.36H160.2a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-4.284a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,423.36Z",
    transform: "translate(0 -196.586)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M155.918,376h3.06a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-3.06a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,376Z",
    transform: "translate(0 -152.898)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M155.918,518.07h9.792a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-9.792a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,518.07Z",
    transform: "translate(0 -283.952)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M262.562,235.954A12.852,12.852,0,1,0,249.71,223.1,12.852,12.852,0,0,0,262.562,235.954Zm0-1.836A11.016,11.016,0,1,0,251.546,223.1,11.016,11.016,0,0,0,262.562,234.118Z",
    transform: "translate(-87.366)",
    fill: "#ff7200",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M395.576,353.933a.077.077,0,0,1-.139-.032,1.836,1.836,0,1,0-.9,1.833s0,0,0,0l-.114.2a.061.061,0,0,0,.028.086l6.891,3.136a.49.49,0,0,0,.487-.844l-6.157-4.4a.065.065,0,0,0-.095.021Z",
    transform: "translate(-218.421 -131.043)",
    fill: "#ff7200",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M405.46,258.618a.918.918,0,1,1-.918-.918.918.918,0,0,1,.918.918",
    transform: "translate(-229.346 -43.771)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M298.906,365.168a.918.918,0,1,1-.918-.918.918.918,0,0,1,.918.918",
    transform: "translate(-131.054 -142.059)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M512.016,365.078a.918.918,0,1,1-.918-.918.918.918,0,0,1,.918.918",
    transform: "translate(-327.64 -141.976)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverspeed);
export default __webpack_public_path__ + "static/media/Overspeed.eab0a41510ca8d86da946bd9b67ffbb2.svg";
export { ForwardRef as ReactComponent };